<script setup lang="ts">
import { computed } from 'vue'
import { BookOpen } from '@lucide/vue'
import type { Comic } from '@tanko/shared'
import type { CollectionMember } from '../../lib/api-client'
import { useLibraryStore } from '../../stores/library'
import { useComicCover } from '../../lib/comic-cover'

/**
 * 封面來源的一個候選：成員的封面縮圖 + 標題。有本機那一份就用本機縮圖，否則走雲端封面。
 * 目前的來源以 aria-pressed 標示，與視覺框線一致。
 */
const props = defineProps<{ member: CollectionMember; current: boolean; disabled?: boolean }>()
const emit = defineEmits<{ choose: [] }>()
const store = useLibraryStore()
const localCopy = computed(() => store.comics.find(comic => comic.cloudComicId === props.member.comicId))
const coverComic = computed<Comic>(() => localCopy.value ?? {
  id: props.member.comicId, libraryId: 'cloud', relPath: '', kind: 'folder', title: props.member.title, author: '',
  pageCount: props.member.pageCount, indexed: true, coverPage: props.member.coverPage,
  cloudComicId: props.member.comicId, syncState: props.member.syncState, addedAt: 0,
})
const { element, cover, failed } = useComicCover(() => coverComic.value, () => localCopy.value ? 'local' : 'cloud')
</script>

<template>
  <button ref="element" type="button" class="collection-cover-option" :aria-pressed="current" :disabled="disabled" :title="member.title" @click="emit('choose')">
    <span class="collection-cover-frame">
      <img v-if="cover && !failed" :src="cover" :alt="`${member.title} 的封面`" @error="failed = true" />
      <BookOpen v-else :size="20" :stroke-width="1.2" aria-hidden="true" />
    </span>
    <span class="collection-cover-title">{{ member.title }}</span>
  </button>
</template>
